import { useCallback, useEffect } from 'react';

type TransactionId = string;
type ErrorMessage = string;

type CapitalizeWindowEventDatatypes = {
  onCapitalize401kStepComplete: TransactionId;
  onCapitalizeExit: true;
  onCapitalizeRolloverCanceled: TransactionId;
  onCapitalizeRolloverCreated: TransactionId;
  onCapitalizeRolloverSubmitted: true;
  onCapitalizeRolloverSubmittedV2: TransactionId;
  onCreateRothDestinationNeeded: TransactionId;
  onCreateRothIra: TransactionId;
  onCreateTradDestinationNeeded: TransactionId;
  onCreateTradIra: TransactionId;
  onError: ErrorMessage;
  onPartnerInternalRolloverRedirect: true;
};
export type CapitalizeWindowEvent = {
  [K in keyof CapitalizeWindowEventDatatypes]: { [P in K]: CapitalizeWindowEventDatatypes[K] };
}[keyof CapitalizeWindowEventDatatypes];

type EventHandlerMap = {
  [K in keyof CapitalizeWindowEventDatatypes]?: (value: Record<K, CapitalizeWindowEventDatatypes[K]>) => void;
};

type EventHandler = (event: CapitalizeWindowEvent) => void;

const useCapitalizeWindowEvents = (handlers: EventHandlerMap) => {
  const handleEvent = useCallback(
    (e: MessageEvent<CapitalizeWindowEvent>) => {
      const { data } = e;
      const definedHandlers = Object.keys(handlers) as Array<keyof EventHandlerMap>;
      definedHandlers.forEach(key => {
        if (key in data) (handlers[key] as EventHandler)?.(data);
      });
    },
    [handlers]
  );

  useEffect(() => {
    window.addEventListener('message', handleEvent);
    return () => window.removeEventListener('message', handleEvent);
  }, [handleEvent]);
};

export default useCapitalizeWindowEvents;
